import db from '@/firebase/init.js'

export const videoStorage = {
  state: {
    videos: [],
    dashboardVideos: [],
    videosFetched: { status: false },
    dashboardVideosFetched: { status: false },
  },
  async fetchAllVideos() {
    if (!this.state.videosFetched.status) {
      // console.log('Fetching all videos!')
      var snapshot = await db.collection('videos').get()
      snapshot.forEach(doc => {
        let video = doc.data()
        video.id = doc.id
        this.state.videos.push(video)
      })
      this.state.videosFetched.status = true
    } else {
      // console.log('All videos already fetched!')
    }

  },
  fetchDashboardVideos(videoAccess) {
    if (!this.state.dashboardVideosFetched.status) {
      // console.log('Fetching latest videos...')
      if (videoAccess) {
        var query = db.collection('videos').orderBy("uploadDate", "desc").limit(4)
      } else {
        var query = db.collection('videos').where("trialVideo", "==", true)       
      }
      query.get().then((snapshot) => {
        snapshot.forEach(doc => {
          let video = doc.data()
          video.id = doc.id
          this.state.dashboardVideos.push(video)
        })
        this.state.dashboardVideosFetched.status = true
      })      
    } else {
      // console.log('Latest videos already fetched!')
    }

  },
  deleteVideo(id) {
    // Delete the video from the main videos array
    var index = this.state.videos.findIndex((video) => {
      return video.id === id
    })
    this.state.videos.splice(index, 1)

    // Delete the video from the latest videos array (if applicable)
    var indexLatest = this.state.dashboardVideos.findIndex((video) => {
      return video.id === id
    }) 
    if (indexLatest !== -1) {
      this.state.dashboardVideos.splice(indexLatest, 1)
    }

  },
  updateVideo(id, newInfo) {
    // Update the video from the main videos array
    var index = this.state.videos.findIndex((video) => {
      return video.id === id
    })
    this.state.videos.splice(index, 1, newInfo)

    // Update the video from the lastest videos array (if applicable)
    var indexLatest = this.state.dashboardVideos.findIndex((video) => {
      return video.id === id
    })
    if (indexLatest !== -1) {
      this.state.dashboardVideos.splice(indexLatest, 1, newInfo)
    }
  },
  resetFetchedStatus() {
    // Empty the video arrays
    this.state.videos.splice(0)
    this.state.dashboardVideos.splice(0)
    // Set the fetched flags to false
    this.state.videosFetched.status = false
    this.state.dashboardVideosFetched.status = false
  }
}